import { toast } from 'react-toastify';

export const handleApiError = (error) => {
   if (error.message.includes('Network Error') || !error.response) {
      toast.error('Network error - make sure API is running', options);
   } else {
      // data
      const { status } = error.response;
      if (status === 404) {
         toast.error('Resource Not found !!!', options);
      }
      if (status === 500) {
         toast.error('Server error', options);
      }
   }
};

export const handleToastNotification = () => {};

const options = {
   position: toast.POSITION.TOP_CENTER,
   autoClose: 3000,
   closeOnClick: true,
   pauseOnHover: true,
   draggable: true,
};
